import { CommonModule } from '@angular/common';
import { AfterViewChecked, ChangeDetectorRef, Component, Inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CategoryDto, Mission, RaceSummaryDto } from '@aoe/client';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { selectRaceList } from 'src/app/core/store/race/race.selector';

@Component({
  selector: 'aoe-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatDialogModule, FormsModule]
})
export class ConfirmationDialogComponent implements OnInit, AfterViewChecked {

  @ViewChild('supRace') supRace!: TemplateRef<any>;
  @ViewChild('supCategory') supCategory!: TemplateRef<any>;
  @ViewChild('supMission') supMission!: TemplateRef<any>;
  @ViewChild('supEvent') supEvent!: TemplateRef<any>;

  public suppRace = 'N';
  public changeRunnerRace = 'N';
  public races$?: Observable<RaceSummaryDto[]>;
  public template!: TemplateRef<any>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { template: string, raceId: string, category?: CategoryDto, mission: Mission.MissionDto },
    // private readonly raceService: RaceService,
    // private readonly adminEventService: AdminEventService,
    // private readonly snackbarService: SnackBarService,
    // private readonly dialogService: DialogService,
    readonly dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    private cd: ChangeDetectorRef,
    private readonly store: Store
  ) { }

  ngOnInit(): void {
    this.races$ = this.store.select(selectRaceList);
  }

  ngAfterViewChecked(): void {
    this.template = (<any>this)[this.data.template as string];
    this.cd.detectChanges();
  }

  deleteRace(): void {
    // if (this.suppRace === 'Y')
    // this.raceService.deleteRace({
    //   raceId: this.data.raceId,
    //   newRace: this.changeRunnerRace === 'N' ? undefined : this.changeRunnerRace
    // }).subscribe({
    //   next: () => {
    //     this.snackbarService.openSnackBar('Le parcours a été supprimé avec succès', 'OK');
    //     this.adminEventService.loadRaces();
    //     this.dialogService.closeConfirmationModal();
    //   },
    //   error: () => {
    //     this.snackbarService.openErrorSnackBar('Echec de la suppression du parcours. Veuillez réessayer ultérieurement');
    //   }
    // })
  }

}
